<div class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3>
        <a [routerLink]="['/reports']">Reports</a> &gt; Sales / Comm Person Report
      </h3>
    </div>
  </div>

  <div class="form-card">
    <!-- Row 1: Person type toggle -->
    <div class="row">
      <div class="col-sm-12 mb-3">
        <label class="filter-label me-2">Person Type:</label>
        <mat-button-toggle-group
          [(ngModel)]="personType"
          (ngModelChange)="onPersonTypeChange()"
          aria-label="Person type">
          <mat-button-toggle value="sales">Marketing Person</mat-button-toggle>
          <mat-button-toggle value="communication">Communication Person</mat-button-toggle>
          <mat-button-toggle value="both">Both</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4 mb-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Report Type</mat-label>
          <mat-select [(value)]="reportType" (selectionChange)="onReportTypeChange()">
            <mat-option value="summary">Summary</mat-option>
            <mat-option value="product_wise_summary">Product Wise Summary</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Row 2: Person dropdown + date range -->
    <div class="row">
      <!-- Person dropdown -->
      <div class="col-sm-4 mb-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Select Person</mat-label>
          <mat-select
            #personSelect
            [(value)]="selectedPersonId"
            (selectionChange)="onPersonSelected($event.value)"
            (openedChange)="onPersonScroll($event)">
            <input
              class="select-input"
              placeholder="Search..."
              type="text"
              autocomplete="nope"
              (keydown)="$event.stopPropagation()"
              (keyup)="onPersonKey($event)" />
            <mat-option [value]="0">All</mat-option>
            <mat-option *ngFor="let e of allPersons" [value]="e.id">
              {{ e.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- From month -->
      <div class="col-sm-3 mb-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>From Month</mat-label>
          <mat-select [(value)]="selectedFromMonthValue">
            <mat-option *ngFor="let opt of monthOptions" [value]="opt.value">
              {{ opt.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- To month -->
      <div class="col-sm-3 mb-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>To Month</mat-label>
          <mat-select [(value)]="selectedToMonthValue">
            <mat-option *ngFor="let opt of monthOptions" [value]="opt.value">
              {{ opt.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Row 3: Generate button -->
    <div class="row">
      <div class="col-sm-4 mb-3">
        <button
          type="button"
          mat-flat-button
          color="primary"
          (click)="generateReport()">
          Generate Report
        </button>
      </div>
    </div>
  </div>
</div>

<div class="report-loading" *ngIf="speaker.isLoading && speaker.listData.length === 0">
  <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
  <span>Loading report...</span>
</div>

<app-report-list-container *ngIf="speaker.listData.length > 0"></app-report-list-container>

